(function() {
    angular
        .module("devicesModule")
        .controller("DevicesController", DevicesController)

    DevicesController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "prefs",
        "devicesService",
        "deviceGroupsService",
        "telemetryService",
        "googleMapsService",
        "userMessagingService",
        "$uibModal"
    ]

    function DevicesController(
        $rootScope,
        $scope,
        $state,
        prefs,
        devicesService,
        deviceGroupsService,
        telemetryService,
        googleMapsService,
        userMessagingService,
        $uibModal
    ){
        "use strict"

        const MAX_MESSAGE_BOARDS_ACTION = 25
        const MAX_MESSAGE_BOARDS_ACTION_CONFIRM = 5

        $rootScope.title = "Devices | WANCO"

        $scope.loading = true

        $scope.sortBy        = prefs.get().devices.sortBy
        $scope.sortDirection = prefs.get().devices.sortOrder
        $scope.perPage       = prefs.get().devices.perPage
        $scope.showLabels    = prefs.get().devices.showMapLabels
        $scope.mapOpen       = prefs.get().devices.showMap
        $scope.mapLegendOpen = prefs.get().devices.showMapLegend
        $scope.showClusters  = prefs.get().devices.showMapClusters

        if ($scope.sortBy === "alerts")       { $scope.sortByTitle = "Alerts"         } else
        if ($scope.sortBy === "model_number") { $scope.sortByTitle = "Model"          } else
        if ($scope.sortBy === "refreshed")    { $scope.sortByTitle = "Date Refreshed" } else { $scope.sortByTitle = "Name" }

        $scope.isFiltered       = false
        $scope.page             = 1
        $scope.searchData       = ""
        $scope.projectList      = "Projects"
        $scope.projects         = {}
        $scope.telemetryService = telemetryService
        $scope.customer         = {}

        $scope.devices            = []
        $scope.messageBoards      = []
        $scope.speedLimitTrailers = []
        $scope.trackers           = []
        $scope.deviceGroups       = []
        $scope.deviceGroupIDs     = undefined

        $scope.selectedAll                       = false
        $scope.selectedAny                       = false
        $scope.selectedDeviceIDs                 = []
        $scope.selectedMessageBoardIDs           = []
        $scope.selectedGenericMessageBoards      = []
        $scope.selectedGenericMessageBoardIDs    = []
        $scope.selectedMessageBoardIDsForRefresh = []
        $scope.selectedSpeedLimitTrailerIDs      = []
        $scope.selectedTrackerIDs                = []
        $scope.selectedGPSDevicesIDs             = []
        $scope.selectedDeviceGroup               = {}

        const organizeDevices = () => {

            $scope.selectedGPSDevicesIDs = []

            let gpsIndex = 0
            let hasGPS   = false

            const setGPSIndex = (device) => {
                if (device.gps.isValid) {
                    gpsIndex++
                    device.gps.index = gpsIndex
                    hasGPS = true
                }
            }

            if ($scope.sortBy === "name") {

                for (const device of $scope.devices) {
                    setGPSIndex(device)
                }

            } else {

                // Re-sort with non-initialized at end

                const initDevices    = []
                const nonInitDevices = []

                for (const device of $scope.devices) {

                    if (device.initialized) {
                        initDevices.push(device)
                    } else {
                        nonInitDevices.push(device)
                    }

                    setGPSIndex(device)

                }

                $scope.devices = initDevices.concat(nonInitDevices)

            }

            $scope.mapOpen = prefs.get().devices.showMap && hasGPS

        }

        let map = undefined

        const handleMap = (forceNewMap) => {
            if (map === undefined || forceNewMap) {
                googleMapsService.createMap("mapConstruct").then((mapObject) => {
                    map = mapObject
                    googleMapsService.setMarkers(true, map, $scope.devices, $scope.showLabels, $scope.showClusters)
                })

            } else {
                googleMapsService.setMarkers(false, map, $scope.devices, $scope.showLabels, $scope.showClusters)
            }
        }

        $scope.toggleLabels = () => {

            $scope.showLabels = !$scope.showLabels
            googleMapsService.toggleMarkerLabels()
            prefs.set(prefs.selectors().devices.showMapLabels, $scope.showLabels)

        }

        $scope.toggleClusters = () => {
            $scope.showClusters = !$scope.showClusters
            prefs.set(prefs.selectors().devices.showMapClusters, $scope.showClusters)
            handleMap()

        }

        const finishGetDevices = (categorized) => {

            // Rarely the list of devices will not be displayed (though devices are in map)
            // Use setTimeout -> $scope.$apply to force

            setTimeout(() => {

                $scope.$apply(() => {

                    $scope.devices       = categorized.all
                    $scope.messageBoards = categorized.messageBoards
                    $scope.trackers      = categorized.trackers


                    for (const device of $scope.devices) {
                        if (device.meta.isMessageBoard && device.meta.inProcess) {
                            device.meta.isRequesting = true
                        }
                    }

                    organizeDevices()

                    $scope.isFiltered  = false

                    $scope.max = devicesService.getTotalDevices()
                    getPageCount()
                    injectNextAutoRefresh()
                    handleMap(true)

                })

            }, 1)
        }

        let dataRetrieve = []
        const gotData = () => {
            if (dataRetrieve.indexOf(false) === -1) {

                $scope.loading = false

            }
        }

        dataRetrieve.push(false)
        devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, $scope.searchData, "", 1, $scope.perPage, (categorized) => {

            finishGetDevices(categorized)

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        dataRetrieve.push(false)
        deviceGroupsService.getDeviceGroups().then((data) => {

            $scope.deviceGroups = data

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        $scope.getDeviceGroups = () => {
            deviceGroupsService.getDeviceGroups().then((data) => {
                $scope.deviceGroups = data
            })
        }

        $scope.getDevices = () => {

            devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, $scope.searchData, "", 1, $scope.perPage, (categorized) => {
                finishGetDevices(categorized)
            })
        }

        $scope.sortDevices = (sortBy, sortByTitle, sortOrder, groupIDs) => {

            devicesService.getDevicesSorted(sortBy, sortOrder, groupIDs, $scope.searchData, "", 1, $scope.perPage, (categorized) => {
                gtag("event", "sort_change", { category: "DEVICES", sort_by: sortBy, direction: sortOrder })

                $scope.sortBy        = sortBy
                $scope.sortByTitle   = sortByTitle
                $scope.sortDirection = sortOrder
                $scope.page          = 1

                finishGetDevices(categorized)

                prefs.set(prefs.selectors().devices.sortBy, sortBy, prefs.selectors().devices.sortOrder, sortOrder)

            })
        }

        $scope.search = (searchData) => {

            devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, searchData || "", "", 1, $scope.perPage, (categorized) => {
                gtag("event", "search", { search_term: searchData || null, category: "DEVICES", group_ids: Object.values($scope.deviceGroupIDs || {}) })
                finishGetDevices(categorized)
            })
        }

        $scope.showOnMap = () => {

            devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, $scope.searchData, $scope.selectedDeviceIDs, 1, $scope.perPage, (categorized) => {

                $scope.mapOpen = true
                finishGetDevices(categorized)
                prefs.set(prefs.selectors().devices.showMap, $scope.mapOpen)

            })
        }

        angular.element(document).find(".device-dropdown-toggle").dropdown("toggle")

        $scope.viewFilteredDeviceGroup = (groupIDs) => {
            $scope.page = 1
            $scope.filterDeviceGroup(groupIDs)
            $scope.refreshSelectedDeviceIDs()
        }

        $scope.filterDeviceGroup = (groupIDs) => {

            if (groupIDs === undefined || (groupIDs.hasOwnProperty("all") && groupIDs.all === true)) {

                $scope.deviceGroupIDs = undefined

            } else {

                $scope.deviceGroupIDs = groupIDs

            }

            devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, "", "", $scope.page, $scope.perPage, (categorized) => {
                gtag("event", "search", { search_term: null, category: "DEVICES", group_ids: Object.values($scope.deviceGroupIDs || {}) })

                finishGetDevices(categorized)

                if ($scope.deviceGroupIDs === undefined) {

                    $scope.projectList = "Projects"
                    $scope.isFiltered  = false
                    $scope.projects    = {}

                } else {

                    $scope.isFiltered = true
                    $scope.searchData = ""

                    const projectList = []

                    for (const deviceGroup of $scope.deviceGroups) {
                        if ($scope.deviceGroupIDs.hasOwnProperty(deviceGroup.id) && $scope.deviceGroupIDs[deviceGroup.id]) {
                            projectList.push(deviceGroup.name)
                        }
                    }

                    $scope.projectList = "Projects: " + projectList.join(", ")

                }
            })
        }

        $scope.createDeviceGroup = (deviceGroupName) => {
            deviceGroupsService.createDeviceGroup(
                deviceGroupName,
                () => {
                    //Success

                    if($scope.deviceGroupIDs) {
                        $scope.page = 1
                        $scope.filterDeviceGroup($scope.deviceGroupIDs)
                    }
                    $scope.getDeviceGroups()
                    $scope.addDeviceGroup = false
                    userMessagingService.success("Project Successfully Created")
                },
                (error) => {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        $scope.selectDeviceGroup = (projectID) => {
            $scope.selectedDeviceGroup = projectID
        }

        $scope.openDeleteMessageBoardModal = (messageBoard) => {

            $uibModal.open({
                templateUrl: "app/modals/delete-message-board.view.html",
                controller: "DeleteMessageBoardModalController",
                resolve: {
                    messageBoard: () => {
                        return messageBoard
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.openDeleteTrackerModal = (tracker) => {

            $uibModal.open({
                templateUrl: "app/modals/delete-tracker.view.html",
                controller: "DeleteTrackerModalController",
                resolve: {
                    tracker: () => {
                        return tracker
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.toggleCheckAll = () => {
            $scope.selectedAll = !$scope.selectedAll
            angular.element(document).find(".device-checkbox").prop("checked", $scope.selectedAll)
            $scope.refreshSelectedDeviceIDs()
        }

        $scope.uncheckSelectedAll = () => {
            angular.element(document).find(".device-checkbox-all").prop("checked", false)
            $scope.selectedAll = false
        }

        $scope.refreshSelectedDeviceIDs = () => {

            $scope.selectedAny                    = false
            $scope.selectedDeviceIDs              = []
            $scope.selectedMessageBoardIDs        = []
            $scope.selectedGenericMessageBoardIDs = []
            $scope.selectedGenericMessageBoards   = []
            $scope.selectedSpeedLimitTrailerIDs   = []
            $scope.selectedTrackerIDs             = []
            $scope.selectedGPSDevicesIDs          = []
            $scope.selectedAnyUserOwned           = false

            const checkboxes = angular.element(document).find(".device-checkbox:checked")

            for (const checkbox of checkboxes) {

                const genericID           = $(checkbox).data("generic-device-id")
                const messageBoardID      = $(checkbox).data("message-board-id")
                const speedLimitTrailerID = $(checkbox).data("speed-limit-trailer-id")
                const trackerID           = $(checkbox).data("tracker-id")

                if (genericID !== undefined) {
                    $scope.selectedDeviceIDs.push(genericID)
                }

                if (messageBoardID !== undefined) {
                    $scope.selectedMessageBoardIDs.push(messageBoardID)
                    for (const messageBoard of $scope.messageBoards) {
                        if (messageBoard.id === messageBoardID) {
                            $scope.selectedAnyUserOwned = $scope.selectedAnyUserOwned || messageBoard.device.user_owned
                            if (messageBoard.initialized && !messageBoard.meta.isMessageBoardSpeedLimitTrailer) {
                                $scope.selectedGenericMessageBoards.push(messageBoard)
                                $scope.selectedGenericMessageBoardIDs.push(messageBoardID)
                            }
                            break
                        }
                    }
                }

                if (speedLimitTrailerID !== undefined) {
                    $scope.selectedSpeedLimitTrailerIDs.push(speedLimitTrailerID)
                }

                if (trackerID !== undefined) {
                    $scope.selectedTrackerIDs.push(trackerID)
                    for (const tracker of $scope.trackers) {
                        if (tracker.id === trackerID) {
                            $scope.selectedAnyUserOwned = $scope.selectedAnyUserOwned || tracker.device.user_owned
                        }
                    }
                }
            }

            if ($scope.selectedDeviceIDs.length > 0) {

                $scope.selectedAny = true

                for (const device of $scope.devices) {
                    if ($scope.selectedDeviceIDs.indexOf(device.device.id) >= 0 && device.gps.isValid === true) {
                        $scope.selectedGPSDevicesIDs.push(device.device.id)
                    }
                }
            }
        }

        $scope.startEditDeviceGroups = () => {
            $scope.editDeviceGroups = true
        }

        $scope.editDeviceGroup = (deviceGroupID, projectName) => {
            deviceGroupsService.editDeviceGroup(
                deviceGroupID,
                projectName,
                () => {
                    //Success

                    if($scope.deviceGroupIDs) {
                        $scope.filterDeviceGroup($scope.deviceGroupIDs)
                    }
                    $scope.getDeviceGroups()

                    $scope.selectedDeviceGroup = false
                    $scope.editDeviceGroups = false
                },
                () => {
                }
            )
        }

        $scope.cancelEditDeviceGroups = () => {
            $scope.editDeviceGroups = false
            $scope.selectedDeviceGroup = 0
        }

        $scope.deleteDeviceGroupPopup = (deviceGroup) => {
            const modalInstance = $uibModal.open({
                templateUrl: "app/modals/delete-device-group-modal.view.html",
                controller: "DeleteDeviceGroupModalController",
                resolve: {
                    deviceGroup: () => {
                        return deviceGroup
                    }
                }
            })

            modalInstance.result.then(() => {
                if($scope.deviceGroupIDs) {
                    $scope.page = 1
                    $scope.filterDeviceGroup($scope.deviceGroupIDs)
                }
                $scope.getDeviceGroups()
                $scope.selectedDeviceGroup = false
                $scope.editDeviceGroups = false
            }, (res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.moveToGroup = (deviceGroupID) => {

            if ($scope.selectedDeviceIDs.length > 0) {

                deviceGroupsService.moveToDeviceGroup(
                    deviceGroupID,
                    $scope.selectedDeviceIDs,
                    () => {
                        //Success

                        if($scope.deviceGroupIDs) {
                            $scope.filterDeviceGroup($scope.deviceGroupIDs)
                        }
                        $scope.getDeviceGroups()
                        $scope.projectsDropdown = false
                        userMessagingService.success("Move to Group Successful")
                    },
                    (error) => {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }

        $scope.removeFromGroup = () => {

            if ($scope.selectedDeviceIDs.length > 0) {

                deviceGroupsService.removeFromDeviceGroup(
                    $scope.selectedDeviceIDs,
                    () => {
                        //Success

                        if($scope.deviceGroupIDs) {
                            $scope.page = 1
                            $scope.filterDeviceGroup($scope.deviceGroupIDs)
                        }
                        $scope.getDeviceGroups()
                        $scope.projectsDropdown = false
                        userMessagingService.success("Remove from Group Successful")
                    },
                    (error) => {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }

        const openNewMessage = (messageBoard, template, controller) => {

            $uibModal.open({
                templateUrl: template,
                controller: controller,
                backdrop: "static",
                keyboard: false,
                windowClass: "createTextModal",
                resolve: {
                    messageBoard: () => {
                        return messageBoard
                    },
                    messageBoardIDs: () => {
                        return [messageBoard.id]
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.openNewMessageText = (messageBoard) => {

            let template   = "app/components/messages/create-text.view.html"
            let controller = "MessageCreateController"

            if (messageBoard.meta.useV2Messaging) {
                template   = "app/components/messages/create-text-v2.view.html"
                controller = "MessageCreateV2Controller"
            }

            openNewMessage(messageBoard, template, controller)

        }

        $scope.openNewMessageGraphic = (messageBoard) => {

            const template   = "app/components/messages/create-graphic.view.html"
            const controller = "MessageCreateGraphicController"

            openNewMessage(messageBoard, template, controller)

        }

        $scope.broadcastMessages = () => {

            if ($scope.selectedGenericMessageBoardIDs.length > 0) {

                $scope.selectedGenericMessageBoardIDsForBroadcast = $scope.selectedGenericMessageBoardIDs.slice(0, MAX_MESSAGE_BOARDS_ACTION)
                $scope.selectedGenericMessageBoardForBroadcast    = $scope.selectedGenericMessageBoards.slice(0, MAX_MESSAGE_BOARDS_ACTION)

                $uibModal.open({
                   templateUrl: "app/modals/broadcast-message-warning-modal.view.html",
                    controller: "BroadcastMessageWarningModalController",
                    resolve: {
                        messageBoards: () => {
                            return $scope.selectedGenericMessageBoardForBroadcast
                        },
                        totalQuantitySelected: () => {
                            return $scope.selectedGenericMessageBoardIDs.length
                        },
                        maxMessageBoardsForAction: () => {
                            return MAX_MESSAGE_BOARDS_ACTION
                        }
                    }
                }).result.then(
                     // Continue
                    () => {

                        let template   = "app/components/messages/create-text.view.html"
                        let controller = "MessageCreateController"

                        // if ($scope.messageBoard.useV2Messaging) {
                            //     template   = "app/components/messages/create-text-v2.view.html"
                            //     controller = "MessageCreateV2Controller"
                        // }

                        $uibModal.open({
                            templateUrl: template,
                            controller: controller,
                            backdrop: "static",
                            keyboard: false,
                            windowClass: "createTextModal",
                            resolve: {
                                messageBoard: () => {
                                    return undefined
                                },
                                messageBoardIDs: () => {
                                    return $scope.selectedGenericMessageBoardIDsForBroadcast
                                }
                            }
                        }).result.catch((res) => {
                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })
                    }
                ).catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
                // $state.transitionTo("messages.text-message", { message_board_id : $scope.selectedGenericMessageBoardIDs })
            }
         }

        $scope.broadcastSpeedDisplay = () => {

            if ($scope.selectedSpeedLimitTrailerIDs.length > 0) {

                const boards = $scope.messageBoards.filter((messageBoard) => { return $scope.selectedSpeedLimitTrailerIDs.indexOf(messageBoard.id) >= 0 && messageBoard.hasOwnProperty("speed_limit_display") })

                if (boards.length > 0) {

                    let startSpeed            = 5
                    let mphCount              = 0
                    let whiteOnBlackCount     = 0
                    let allowStyleChangeCount = boards.length
                    let enableBeacons         = false
                    let beaconsCount          = 0

                    for (const board of boards) {
                        mphCount = board.speed_limit_display.units === "MPH" ? mphCount + 1 : mphCount - 1
                        whiteOnBlackCount = board.speed_limit_display.white_on_black ? whiteOnBlackCount + 1 : whiteOnBlackCount - 1
                        allowStyleChangeCount = board.speed_limit_display.allow_style_change ? allowStyleChangeCount : allowStyleChangeCount - 1
                        startSpeed = Math.max(startSpeed, board.speed_limit_display.speed)
                        if (board.beacons.available) {
                            enableBeacons = true
                            beaconsCount += 1
                        }
                    }

                    $uibModal.open({
                        templateUrl: "app/modals/broadcast-speed-warning-modal.view.html",
                        controller: "BroadcastSpeedWarningModalController",
                        resolve: {
                            options: () => {
                                return {
                                    messageBoardIDs: $scope.selectedSpeedLimitTrailerIDs,
                                    baseImageURL:    boards[0].speed_limit_display.base_image_url,
                                    mixedUnits:      Math.abs(mphCount) !== boards.length,
                                    enableBeacons:   enableBeacons,
                                    mixedBeacons:    enableBeacons && beaconsCount !== boards.length,
                                    mixedAllowStyleChange: allowStyleChangeCount !== boards.length && allowStyleChangeCount > 0,
                                    startDisplaySettings: {
                                        speed:              startSpeed > 85 && mphCount >= 0 ? 85 : startSpeed,
                                        units:              mphCount >= 0 ? "MPH" : "KPH",
                                        white_on_black:     whiteOnBlackCount > 0,
                                        allow_style_change: allowStyleChangeCount > 0,
                                        beacons:            false
                                    }
                                }
                            }
                        }
                    }).result.catch((res) => {
                        if (!(res === "cancel" || res === "escape key press")) {
                            throw res
                        }
                    })
                }
            }
        }

        $scope.updateMessageBoards = () => {

            const performRefresh = () => {

                $scope.selectedMessageBoardIDsForRefresh = $scope.selectedMessageBoardIDs.slice(0, MAX_MESSAGE_BOARDS_ACTION)

                for (const messageBoard of $scope.messageBoards) {
                    if ($scope.selectedMessageBoardIDsForRefresh.indexOf(messageBoard.id) !== -1) {
                        $scope.updateMessageBoard(messageBoard)
                    }
                }
            }

            if ($scope.selectedMessageBoardIDs.length <= MAX_MESSAGE_BOARDS_ACTION_CONFIRM) {

                performRefresh()

            } else {

                $uibModal.open({
                    templateUrl: "app/modals/device-action-refresh-modal.view.html",
                    controller: "DeviceActionRefreshModalController",
                    resolve: {
                        performRefresh: () => {
                            return performRefresh
                        },
                        quantitySelected: () => {
                            return $scope.selectedMessageBoardIDs.length
                        },
                        maxMessageBoardsForAction: () => {
                            return MAX_MESSAGE_BOARDS_ACTION
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        $scope.updateMessageBoard = (messageBoard) => {
            if (!messageBoard.meta.inProcess) {
                telemetryService.refreshTelemetry("MessageBoard", messageBoard.id,
                    () => {
                        //Success
                        messageBoard.meta.isRequesting = true
                    },
                    () => {
                        //Failure
                    }
                )
            }
        }

       $scope.moveToCustomer = () => {

            if ($scope.selectedDeviceIDs.length > 0) {
                let noDoubleCalls = true
                $uibModal.open({
                    templateUrl: "app/modals/move-to-customer-modal.html",
                    controller: "MoveToCustomerModalController",
                    resolve: {
                        deviceIDs: () => {
                            return $scope.selectedDeviceIDs
                        },
                        success: () => {
                            return () => {
                                if (noDoubleCalls) {
                                    noDoubleCalls = false
                                    userMessagingService.success("Move to Customer Successful")
                                    $scope.getDevices()
                                    $scope.uncheckSelectedAll()
                                }
                            }
                        },
                        failure: () => {
                            return () => {
                                if (noDoubleCalls) {
                                    noDoubleCalls = false
                                    userMessagingService.error("Move to Customer Failed")
                                }
                            }
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        }

        const mapHeightWhileLegendOpen   = Number($("#mapContainer").css("height").match(/\d+/g))
        const mapLegendHeight            = Number($("#mapLegendSection").css("height").match(/\d+/g))
        const mapHeightWhileLegendClosed = mapHeightWhileLegendOpen - mapLegendHeight

        if (!$scope.mapOpen) {

            $("#mapContainer").css("height", "0px")
            $("#mapContainer").css("visibility", "hidden")
            $("#mapOptions").css("opacity", 0)
            $("#mapOptions").css("visibility", "hidden")

        } else if (!$scope.mapLegendOpen) {

            $("#mapContainer").css("height", String(mapHeightWhileLegendClosed) + "px")

        }

        let mapChangeProceedOpen  = true
        let mapChangeProceedClose = true
        let mapLegendChangeProceedOpen  = true
        let mapLegendChangeProceedClose = true

        $scope.toggleLegend = () => {

            const duration = 125
            const factor = 15

            const mapContainer = $("#mapContainer")

            const close = () => {
                if (mapLegendChangeProceedClose) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height - Math.ceil((height - mapHeightWhileLegendClosed) / factor)

                    if (newHeight > mapHeightWhileLegendClosed) {

                        mapContainer.css("height", String(newHeight) + "px")

                        setTimeout(() => {
                            close()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightWhileLegendClosed) + "px")

                        prefs.set(prefs.selectors().devices.showMapLegend, $scope.mapLegendOpen)

                    }
                }
            }

            const open = () => {

                if (mapLegendChangeProceedOpen) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height + Math.ceil((mapHeightWhileLegendOpen - height) / factor)

                    if (newHeight < mapHeightWhileLegendOpen) {

                        mapContainer.css("height", String(newHeight) + "px")

                        setTimeout(() => {
                            open()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightWhileLegendOpen) + "px")

                        prefs.set(prefs.selectors().devices.showMapLegend, $scope.mapLegendOpen)

                    }
                }
            }

            if ($scope.mapLegendOpen) {

                mapLegendChangeProceedClose = true
                mapLegendChangeProceedOpen  = false
                $scope.mapLegendOpen = false
                close()

            } else {

                mapLegendChangeProceedClose = false
                mapLegendChangeProceedOpen  = true
                $scope.mapLegendOpen = true
                open()

            }
        }

        $scope.toggleMap = () => {

            const duration = 125
            const factor = 15

            const mapContainer = $("#mapContainer")
            const mapOptions   = $("#mapOptions")

            const close = () => {

                if (mapChangeProceedClose) {

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height - Math.ceil(height / factor)
                    let newOpacity = Number(mapOptions.css("opacity")) - (0.8 / factor)

                    if (newHeight > 0) {

                        mapContainer.css("height", String(newHeight) + "px")
                        mapOptions.css("opacity", newOpacity)
                        setTimeout(() => {
                            close()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", "0px")
                        mapContainer.css("visibility", "hidden")
                        mapOptions.css("opacity", 0)
                        mapOptions.css("visibility", "hidden")

                        prefs.set(prefs.selectors().devices.showMap, $scope.mapOpen)

                    }
                }
            }

            const open = () => {

                if (mapChangeProceedOpen) {

                    const mapHeightBase = $scope.mapLegendOpen ? mapHeightWhileLegendOpen : mapHeightWhileLegendClosed

                    mapContainer.css("visibility", "visible")
                    mapOptions.css("visibility", "visible")

                    let height = Number(mapContainer.css("height").match(/\d+/g))
                    let newHeight = height + Math.ceil((mapHeightBase - height) / factor)
                    let newOpacity = Number(mapOptions.css("opacity")) + (1 / factor)

                    if (newHeight < mapHeightBase) {

                        mapContainer.css("height", String(newHeight) + "px")
                        mapOptions.css("opacity", newOpacity)

                        setTimeout(() => {
                            open()
                        }, (duration / factor))

                    } else {

                        mapContainer.css("height", String(mapHeightBase) + "px")
                        mapOptions.css("opacity", 1)

                        prefs.set(prefs.selectors().devices.showMap, $scope.mapOpen)

                    }
                }
            }

            if ($scope.mapOpen) {

                mapChangeProceedOpen  = false
                mapChangeProceedClose = true
                $scope.mapOpen = false
                close()

            } else {

                mapChangeProceedClose = false
                mapChangeProceedOpen  = true
                $scope.mapOpen = true
                handleMap()
                open()

            }
        }

        $scope.changePerPage = (perPage) => {

            $scope.perPage = perPage
            $scope.page = 1

            if (perPage !== "All") {
               prefs.set(prefs.selectors().devices.perPage, perPage)
            }

            getPageCount()
            $scope.getData()
        }

        $scope.changePage = (page) => {
            const newPage = $scope.page + page

            if(newPage < 1 || newPage > $scope.maxPages) {
                return
            }

            $scope.page = newPage
            $scope.getData()
        }

        $scope.getData = () => {
            if($scope.isFiltered == true) {
                $scope.filterDeviceGroup($scope.deviceGroupIDs)
            } else {
                devicesService.getDevicesSorted($scope.sortBy, $scope.sortDirection, $scope.deviceGroupIDs, $scope.searchData, "", $scope.page, $scope.perPage, (categorized) => {

                    finishGetDevices(categorized)

                })
            }
        }

        const injectNextAutoRefresh = (messageBoard) => {

            if (messageBoard !== undefined) {
                if (messageBoard.hasOwnProperty("telemetry") &&
                    messageBoard.device.hasOwnProperty("timezone_iana") &&
                    messageBoard.telemetry.hasOwnProperty("auto_refresh") &&
                    messageBoard.telemetry.auto_refresh.interval_seconds > 0
                ) {
                    messageBoard.nextAutoRefresh = moment(messageBoard.telemetry.auto_refresh.next_refresh).tz(messageBoard.device.timezone_iana).format("MMM. Do, HH:mm z")
                }
            } else {

                for (const messageBoard of $scope.messageBoards) {
                    if (messageBoard.hasOwnProperty("telemetry") &&
                        messageBoard.device.hasOwnProperty("timezone_iana") &&
                        messageBoard.telemetry.hasOwnProperty("auto_refresh") &&
                        messageBoard.telemetry.auto_refresh.interval_seconds > 0
                    ) {
                        messageBoard.nextAutoRefresh = moment(messageBoard.telemetry.auto_refresh.next_refresh).tz(messageBoard.device.timezone_iana).format("MMM. Do, HH:mm z")
                    }
                }
            }
        }

        const getPageCount = () => {
            $scope.maxPages = Math.ceil($scope.max / $scope.perPage)
        }

        $scope.$watch("$root.pushedData", (pushedData) => {

            if (pushedData.device.hasOwnProperty("device")) {

                for (const device of $scope.devices) {

                    if (pushedData.device.device.id === device.device.id) {

                        const wasUserOwned = device.device.user_owned ? true : false

                        $rootScope.deepOverwrite(device, pushedData.device)

                        device.device.user_owned = wasUserOwned

                        if (device.meta.isMessageBoard) {
                            injectNextAutoRefresh(device)
                        }

                        organizeDevices()
                        handleMap()

                        break

                    }
                }
            } else if (!pushedData.reload && pushedData.deviceID > 0) {

                for (const device of $scope.devices) {

                    if (pushedData.deviceID === device.device.id) {

                        device.meta.isRequesting = false
                        device.meta.inProcess    = false
                        break

                    }
                }
            }
        })
    }
})()
